import { render, staticRenderFns } from "./admin_sel_internacion.vue?vue&type=template&id=58055527&"
import script from "./admin_sel_internacion.js?vue&type=script&lang=js&"
export * from "./admin_sel_internacion.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports